import axios from './../../libs/api.request'

export function add (data) {
  return axios.request({
    url: '/sku/add',
    method: 'post',
    data
  })
}

export function update (data) {
  return axios.request({
    url: '/sku/update',
    method: 'post',
    data
  })
}

export function querySku (data) {
  return axios.request({
    url: '/sku/list',
    method: 'post',
    data
  })
}

export function recharge (data) {
  return axios.request({
    url: '/order/recharge',
    method: 'post',
    data
  })
}

export function consume (data) {
  return axios.request({
    url: '/order/consume',
    method: 'post',
    data
  })
}

export function operationByPath (path) {
  return axios.request({
    url: path,
    method: 'get'
  })
}

export function deleteByIds (data) {
  return axios.request({
    url: '/sku/deleteByIds',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/components/sku/skuApi.js